import {connect} from "react-redux"
import {IncomingHttpHeaders} from "http"
import {createSelector} from "reselect"
import State from "../../ducks/state"
import urls from "../../config/urls"
import {ENRICHED_SEARCH, REALM_HEADER, SIMPLE_SEARCH} from "../../config/constants"
import {closeAllPanels, openDrawer} from "../../ducks/search"

const textSelector = createSelector(
    (state: State) => state.text,
    text => {
        const {
            searchBox: {closeButton, smallPlaceholder, bigPlaceholder},
            drawer,
        } = text
        return {closeButton, smallPlaceholder, bigPlaceholder, drawer}
    },
)

export const mapStateToProps = (state: State) => {
    const realm = (state.request.headers as IncomingHttpHeaders)[REALM_HEADER] as string
    const {variant, showCloseButtonMobileSearch, iconsVersionPath, enableRecentSearches} = state.settings
    const {numFound, suggestions} = state.autocomplete
    const isNoResults = suggestions && suggestions.length === 0 && numFound === 0
    const isAutocompleteEnabled = state.settings.autocompleteEnabled
    const showAutoComplete = isAutocompleteEnabled && state.search.showAutocomplete
    const searchBarType = state.settings.enrichedSearchEnabled ? ENRICHED_SEARCH : SIMPLE_SEARCH

    return {
        checkRecentSearch: state.recents.queryIds.length > 0,
        showAutoComplete,
        showRecentSearch: state.search.showRecentSearch,
        iconUrl: urls.searchBox.searchIconUrl(realm, variant, iconsVersionPath),
        searchBarType,
        typedCharacters: state.search.typedCharacters,
        text: textSelector(state),
        isNoResults,
        showCloseButton: showCloseButtonMobileSearch,
        templating: state.template,
        enableRecentSearches,
    }
}

export const mapDispatchToProps = (dispatch: any) => ({
    handleClose: () => dispatch(closeAllPanels()),
    openDrawer: () => dispatch(openDrawer()),
})

export default connect(mapStateToProps, mapDispatchToProps)
